import { render, staticRenderFns } from "./InwardGoodsList.vue?vue&type=template&id=371bc4a4&"
import script from "./InwardGoodsList.vue?vue&type=script&lang=js&"
export * from "./InwardGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./InwardGoodsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports